import gsap from "gsap"
import CustomEase from "gsap/CustomEase"
import PixiPlugin from "gsap/PixiPlugin"
import TextPlugin from "gsap/TextPlugin"
import * as PIXI from 'pixi.js';
import { iconStates } from "../constants/symbolsNames";
import { gameConfigurationStore } from "../gameModule/store/gameConfigurationStore";

const setupPixiPlugins = () => {
    gsap.registerPlugin(PixiPlugin);
    gsap.registerPlugin(TextPlugin);
    gsap.registerPlugin(CustomEase);
    PixiPlugin.registerPIXI(PIXI);
}

const createCustomEases = () => {
    CustomEase.create(
        'customStopNormal',
        'M0,0 C0,0 0.468,1.064 0.468,1.064 0.468,1.064 0.413,1.064 1,1  '
    );
    CustomEase.create(
        'customStopFast',
        'M0,0 C0,0 0.011,0.028 0.366,1.102 0.741,1.022 0.396,1.074 0.74,1.022 1,1 0.8,1.019 1,1 '
    );
    CustomEase.create(
        'customStopTurbo',
        'M0,0 C0,0 0.422,1 0.443,1.027 0.473,1.064 0.533,1.063 0.533,1.063 0.533,1.063 0.692,1.028 1,1 '
    );
}

const handleReelIconStateInWinCase = (allLinesMatrix, reel) => {
    const reelVisibleiconStates = new Array(reel.visibleRows);
    for (let j = 0; j < reel.visibleRows; j++) {
        reelVisibleiconStates[j] = allLinesMatrix[j][reel.index] === 1 ? iconStates.win : iconStates.noWin;
    }
    return reelVisibleiconStates;
}

const handleWinLineBonePosition = (lines, reel) => {
    for (let j = reel.visibleRows; j < reel.visibleRows * 2; j++) {
        if (lines[j - reel.visibleRows]?.[reel.index]) {
            const entry = gameConfigurationStore.reelsParams[reel.index]?.iconsFinalPositions?.inWinContainer?.[j];
            if (entry !== undefined) return -entry.yInWin;
        }
    }
}


export { setupPixiPlugins, createCustomEases, handleReelIconStateInWinCase, handleWinLineBonePosition }